/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TillInputs */

const en__field_till = /** @type {(inputs: _Field_TillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Until`)
};

const de__field_till = /** @type {(inputs: _Field_TillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis`)
};

/**
* | output |
* | --- |
* | "Until" |
*
* @param {_Field_TillInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_till = /** @type {((inputs?: _Field_TillInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TillInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_till(inputs)
	return de__field_till(inputs)
});